var exports = {
  "R_": "heading__n2YdSJ",
  "xq": "legacyDockedHeader__uPww67",
  "Kp": "dockedHeader__U4oSmI",
  "$": "titleRow__cKBngj",
  "$s": "headerActions__KW3udJ",
  "nd": "panel__iqwvJ0",
  "wx": "header__FDFbr3",
  "b": "closeButton__ef2Uoz",
  "rf": "body__2uOH1H",
};

module.exports = exports;
